import router from "@/router/router";
import store from "@/store";
import { ErrorService } from "@/framework/errors/ErrorService";
import { InquiryService } from "@/framework/api/Staff/ChatService/InquiryService";
import { QcConversation } from "../objects/conversation/QcConversation";
import { BizConversationState } from "../objects/hotelStaff";

export const getInquiryImportanceColor = (importance: number, conversation?: QcConversation): string => {
  if (importance >= 9) {
    return "#F0D5D8";
  } else if (importance >= 7) {
    return "#F8E0B6";
  } else if (importance >= 3) {
    return "#FFFFFF";
  } else if (
    importance == 0 &&
    conversation &&
    conversation.biz_conv_info &&
    conversation.biz_conv_info.is_sms_chat &&
    conversation.biz_conv_info.state == BizConversationState.IDLING
  ) {
    // KTZNCHAT-15655 [In-room][Staff][PWA] Change Sort Order and Color for “SMS Sent” Status Chats
    return "#FFFFFF";
  }
  return "#E8E8E8";
};

export const checkExistInquiry = async (langCd: string) => {
  // アプリが復帰したときに問い合わせがないか確認する用のメソッド
  // 返り値で情報を入れる
  // -1: カスタマーサービスモードではないときは何もしない
  // 0: InquiryInfoなし or inquiry_idなし
  // 1: InquiryIdはあるけどbusyではない(現在他で対応中ではない)
  // 2: InquiryIdはありbusy(現在他で対応中)
  // 3: inquiry_busyがbusyではなくなった
  // const staff: StaffStore = store.getters.staff;

  // if (!isEmpty(staff) && !isEmpty(staff.myself) && staff.myself.role !== "staff") return;

  if (!store.getters.appMode || store.getters.appMode !== "customer_service") return -1;

  const res = await new InquiryService().getInquiry();
  if (res.isErr()) {
    await new ErrorService().handleError(res.error);
    return 0;
  }

  const inquiryInfo = res.value;
  if (inquiryInfo && inquiryInfo.is_busy) {
    return 2;
  } else if (inquiryInfo && inquiryInfo.inquiry_id && !store.getters.fromInquiryHistory) {
    moveInquiryPage(langCd, inquiryInfo.inquiry_id.toString());
    if (store.getters.isStaffBusy && !inquiryInfo.is_busy) return 3;
    return 1;
  }

  return 0;
};

export const moveInquiryPage = (langCd: string, inquiryId: string) => {
  // ログインステータス/会話一覧/(インタラクティブ)翻訳画面/設定画面/ユーザー名編集画面/通知設定画面/言語設定画面であればOK
  // 会話画面で対応中ではなければOK
  const nowRoute = location.pathname;
  if (
    inquiryId &&
    (nowRoute.search(/staff\/login\/status/) >= 0 ||
      nowRoute.search(/conversations/) >= 0 ||
      nowRoute.search(/translation/) >= 0 ||
      nowRoute.search(/settings/) >= 0 ||
      nowRoute.search(/username/) >= 0 ||
      nowRoute.search(/notification/) >= 0 ||
      nowRoute.search(/languages/) >= 0 ||
      nowRoute.search(/conversation\//) >= 0)
  ) {
    // inquiry_idが入っていたら(問い合わせだったら)
    router.push(`/${langCd}/biz/staff/inquiry/${inquiryId}`);
  }
};
